// Tek kaynaklı site navigasyonu.
// Header ve Footer, route hedeflerini yalnızca buradan okur.
import { exams, levels, legalPages, categories } from "./content";
import { studentMenu, ogretmenMenu, veliMenu, adminMenu } from "./panels";

export interface NavItem {
  label: string;
  href: string;
}

export interface SearchItem {
  label: string;
  href: string;
  keywords: string;
  group?: string;
}

export interface FooterLink {
  label: string;
  href: string;
}

export interface FooterColumn {
  title: string;
  links: FooterLink[];
}

// Ana menü — tek düzey, doğrudan navigasyon.
export const mainNav: NavItem[] = [
  { label: "Ana Sayfa", href: "/" },
  {label:"Programlarımız",href:"/programlarimiz"},
  { label: "Eğitimler", href: "/egitimler" },
  { label: "Konu Anlatımları", href: "/konu-anlatimlari" },
  { label: "Sınıflar", href: "/siniflar" },
  { label: "Sınavlar", href: "/sinavlar" },
  { label: "Canlı Dersler", href: "/canli-dersler" },
  { label: "Soru Bankası", href: "/soru-bankasi" },
  { label: "Deneme Sınavları", href: "/deneme-sinavlari" },
  { label: "Öğretmenler", href: "/ogretmenler" },
  { label: "Paketler", href: "/paketler" },
];

// Üst bilgi bandı yardımcı linkleri.
export const utilityLinks: NavItem[] = [
  { label: "Hakkımızda", href: "/hakkimizda" },
  { label: "Yardım Merkezi", href: "/yardim" },
  { label: "İletişim", href: "/iletisim" },
];

// Üye girişi rol menüsü — her ikisi de ortak giriş sayfasına yönlendirir.
export const roleLinks: NavItem[] = [
  { label: "Öğrenci Girişi", href: "/giris?rol=ogrenci" },
  { label: "Veli Girişi", href: "/giris?rol=veli" },
  { label: "Öğretmen Girişi", href: "/ogretmen/giris" },
  { label: "Kurum Girişi", href: "/kurum/giris" },
];

// Client-side arama indeksi — tüm siteyi tarar: genel sayfalar,
// sınavlar, sınıflar, yasal sayfalar, kategori içerikleri ve tüm paneller.
export const searchIndex: SearchItem[] = [
  {label:"Programlarımız",href:"/programlarimiz",keywords:"uygulama indir mobil meraklı toplantı windows android kurulum kullanım",group:"Sayfa"},
  { label: "Ana Sayfa", href: "/", keywords: "dersdinle başlangıç platform anasayfa", group: "Sayfa" },
  { label: "Eğitimler", href: "/egitimler", keywords: "video ders konu anlatımı arşiv soru çözümü tekrar ders notları", group: "Sayfa" },
  { label: "Sınıflar", href: "/siniflar", keywords: "okul öncesi ilkokul ortaokul lise seviye sınıf", group: "Sayfa" },
  { label: "Sınavlar", href: "/sinavlar", keywords: "sınav hazırlık lgs tyt ayt kpss dgs ales yds yökdil ydt", group: "Sayfa" },
  { label: "Canlı Dersler", href: "/canli-dersler", keywords: "canlı ders kayıt canlı sınıf soru cevap haftalık program", group: "Sayfa" },
  { label: "Soru Bankası", href: "/soru-bankasi", keywords: "soru test çözüm konu testi zorluk yanlış takibi", group: "Sayfa" },
  { label: "Deneme Sınavları", href: "/deneme-sinavlari", keywords: "deneme net analiz sınav formatı süre yönetimi gelişim takibi", group: "Sayfa" },
  { label: "Öğretmenler", href: "/ogretmenler", keywords: "öğretmen rehberlik koçluk canlı ders soru çözümü", group: "Sayfa" },
  { label: "Paketler", href: "/paketler", keywords: "paket plan üyelik abonelik fiyat", group: "Sayfa" },
  { label: "Online Eğitim", href: "/online-egitim", keywords: "online eğitim online eğitim dijital eğitim video ders canlı ders", group: "Sayfa" },
  { label: "Online Deneme Sınavı", href: "/online-deneme-sinavi", keywords: "online deneme sınavı net analiz süre yönetimi gelişim takibi", group: "Sayfa" },
  { label: "Hakkımızda", href: "/hakkimizda", keywords: "kurumsal yaklaşım misyon vizyon", group: "Sayfa" },
  { label: "İletişim", href: "/iletisim", keywords: "destek yardım iletişim bilgi sss", group: "Sayfa" },
  { label: "Yardım Merkezi", href: "/yardim", keywords: "sss sık sorulan rehber rota canlı ders veli takibi soru desteği", group: "Sayfa" },
  { label: "Giriş Yap", href: "/giris", keywords: "giriş login öğrenci veli hesap üye", group: "Sayfa" },
  { label: "Kayıt Ol", href: "/kayit", keywords: "kayıt üyelik hesap oluştur", group: "Sayfa" },
  ...exams.map((e) => ({
    label: `${e.shortName} — ${e.fullName}`,
    href: `/sinavlar/${e.slug}`,
    keywords: `${e.shortName} ${e.fullName} ${e.subjects.join(" ")} ${e.description}`,
    group: "Sınav",
  })),
  ...levels.map((l) => ({
    label: `${l.name} — ${l.title}`,
    href: `/siniflar/${l.slug}`,
    keywords: `${l.name} ${l.title} ${l.subjects.join(" ")} ${l.description}`,
    group: "Sınıf",
  })),
  ...legalPages.map((p) => ({
    label: p.title,
    href: `/${p.slug}`,
    keywords: p.title,
    group: "Yasal",
  })),
  ...Object.values(categories).flatMap((c) =>
    c.areas.map((a) => ({
      label: `${c.crumb} — ${a.title}`,
      href: `/${c.slug}`,
      keywords: `${c.title} ${a.title} ${a.text}`,
      group: c.crumb,
    }))
  ),
  ...studentMenu.map((m) => ({
    label: m.label,
    href: m.href,
    keywords: `öğrenci paneli ${m.label}`,
    group: "Öğrenci Paneli",
  })),
  ...ogretmenMenu.map((m) => ({
    label: m.label,
    href: m.href,
    keywords: `öğretmen paneli ${m.label}`,
    group: "Öğretmen Paneli",
  })),
  ...veliMenu.map((m) => ({
    label: m.label,
    href: m.href,
    keywords: `veli paneli ${m.label}`,
    group: "Veli Paneli",
  })),
  ...adminMenu.map((m) => ({
    label: m.label,
    href: m.href,
    keywords: `yönetici paneli ${m.label}`,
    group: "Yönetici Paneli",
  })),
];

export const footerColumns: FooterColumn[] = [
  {
    title: "Eğitimler",
    links: [
      { label: "İlkokul", href: "/siniflar/ilkokul" },
      { label: "Ortaokul", href: "/siniflar/ortaokul" },
      { label: "Lise", href: "/siniflar/lise" },
      { label: "TYT", href: "/sinavlar/tyt" },
      { label: "AYT", href: "/sinavlar/ayt" },
      { label: "KPSS", href: "/sinavlar/kpss" },
    ],
  },
  {
    title: "Platform",
    links: [
      { label: "Online Eğitim", href: "/online-egitim" },
      { label: "Online Deneme Sınavı", href: "/online-deneme-sinavi" },
      { label: "Konu Anlatımları", href: "/konu-anlatimlari" },
      { label: "Canlı Dersler", href: "/canli-dersler" },
      { label: "Soru Bankası", href: "/soru-bankasi" },
      { label: "Deneme Sınavları", href: "/deneme-sinavlari" },
    ],
  },
  {
    title: "Kurumsal",
    links: [
      { label: "Hakkımızda", href: "/hakkimizda" },
      { label: "İletişim", href: "/iletisim" },
      { label: "KVKK", href: "/kvkk" },
      { label: "Gizlilik Politikası", href: "/gizlilik-politikasi" },
      { label: "Kullanıcı Sözleşmesi", href: "/kullanici-sozlesmesi" },
      { label: "Çerez Politikası", href: "/cerez-politikasi" },
    ],
  },
  {
    title: "Destek",
    links: [
      { label: "Yardım Merkezi", href: "/yardim" },
      { label: "Sık Sorulan Sorular", href: "/yardim" },
      { label: "İletişim", href: "/iletisim" },
    ],
  },
];
